import { render, staticRenderFns } from "./MembersStatements.vue?vue&type=template&id=468e74f2&scoped=true&"
import script from "./MembersStatements.vue?vue&type=script&lang=js&"
export * from "./MembersStatements.vue?vue&type=script&lang=js&"
import style0 from "./MembersStatements.vue?vue&type=style&index=0&id=468e74f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468e74f2",
  null
  
)

export default component.exports